import { post } from '@va/http-client';
import { jwtDecode } from 'jwt-decode';

export type TokenResponsePayload = {
  clientId: string;
  companyId: string;
  refreshToken: string;
  token: string;
};

export type AuthenticateWithTokenResponse = {
  payload: TokenResponsePayload;
};

export async function authenticateWithToken(
  intpcToken: string,
): Promise<Pick<TokenResponsePayload, 'refreshToken' | 'token'> & { userId: string }> {
  const url = `/v2/token`;

  const {
    payload: { clientId: userId, token, refreshToken },
  }: AuthenticateWithTokenResponse = await post(url, {}, { token: intpcToken });

  return { userId, token, refreshToken };
}

export async function websiteTokenRefresh(
  refreshToken: string,
): Promise<{ token: string; refreshToken: string; websiteId: string }> {
  return await post('/api-key/token-refresh', {}, { refreshToken: refreshToken });
}

export const generateImpersonateToken = async (data: { email: string; password: string; impersonate: string }) => {
  const response = await post<{
    payload: { token: string; refreshToken: string; impersonate: string; intp_id: string };
  }>(`/v2/impersonate/token`, {}, data);

  const decodedToken = jwtDecode<{ userId?: string }>(response.payload.token);

  return { ...response.payload, clientId: decodedToken.userId || '' };
};

export async function impersonateTokenRefresh(payload: { refreshToken: string }) {
  const {
    payload: { intp_id, ...response },
  } = await post<{ payload: { token: string; refreshToken: string; impersonate: string; intp_id: string } }>(
    '/v2/impersonate/token-refresh',
    {},
    payload,
  );

  const decodedToken = jwtDecode<{ userId?: string }>(response.token);

  return { ...response, clientId: decodedToken.userId || '', companyId: intp_id };
}
